export default __webpack_public_path__ + "static/media/cdk.33cfaf8e.png";